export const engagementInitialState = {
  engagements: {
    currentListSize: 0,
    hasMoreElement: false,
    offset: 0,
    values: [],
    totalSize: 0,
  },
  allInformation: {},
  isLoading: false,
};
